<asax-header-search-input-info [searchInput]="searchInput">
  <content *ngTemplateOutlet="content"></content>
</asax-header-search-input-info>

<ng-template #content>
  <div class="text-nowrap">
    <label id="{{'header-filter-label-' + searchInput.id}}"
           for="{{'search-input-' + searchInput.id}}"
           class="form-label mb-0 me-1">
      {{searchInput.label}}
    </label>
    <i *ngIf="searchInput.isDisabled"
       class="fa-light fa-eye-slash me-1"
       placement="right"
       ngbTooltip="Filter is disabled">
    </i>
  </div>
  <div ngbDropdown
       [autoClose]="'outside'">
    <div class="input-group input-group-sm has-validation">
      <button ngbDropdownToggle
              id="{{'header-filter-' + searchInput.id}}"
              type="button"
              class="form-control"
              [class.is-valid]="searchInput.value?.length > 0"
              [class.border-radius-right-0]="searchInput.value?.length > 0">
        {{valueToDisplay}}
      </button>
      <button *ngIf="searchInput.value?.length > 0"
              type="button"
              class="btn btn-light border-dark"
              (click)="clearSearchInputValue()">
        <i class="fa-light fa-xmark"></i>
      </button>
    </div>
    <div ngbDropdownMenu style="width: 100%;">
      <ng-container *ngFor="let dropdownItem of searchInput.dropdownItems">
        <button ngbDropdownItem
             id="{{dropdownItem.value}}"
             (click)="onDropdownItemClick(dropdownItem)"
             [class.active]="dropdownItem.selected">
          {{dropdownItem.text}}
          <span *ngIf="dropdownItem.info"
                class="small text-muted ms-2">
          {{dropdownItem.info}}
        </span>
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
